import { CallState } from "@b2bportal/core-types";
import type { CarShopState } from "./types";

export const initialCarShopState: CarShopState = {
  shopCallState: CallState.NotCalled,
  shop: undefined,
  selectedVehicle: undefined,
};
